import { ComponentType, FC } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { useAuthentication } from '../../components/AuthenticationProvider';
import routes from '../../paths.json';
import { stringifyQuery } from '../../utils/location';

const withAuthentication = (Component: ComponentType): ComponentType => {
  const WithAuthentication: FC = (props) => {
    const { authenticated } = useAuthentication();
    const location = useLocation();

    if (!authenticated) {
      return (
        <Redirect
          to={{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            pathname: routes.login,
            search: stringifyQuery({
              redirect: `${location.pathname}${location.search}`,
            }),
          }}
        />
      );
    }

    return <Component {...props} />;
  };

  const componentName = Component.displayName || 'Component';

  WithAuthentication.displayName = `withAuthentication(${componentName})`;

  return WithAuthentication;
};

export default withAuthentication;
